import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "agenda" */ './index'),
  loading: () => null,
});
